
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 23 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21 5H1v10a2 2 0 002 2h12.25l3.008-3.008a2 2 0 012.742-.08V5z","fill":"#FFF5E8"}}),_c('path',{attrs:{"d":"M19.121 19.382a.5.5 0 01-.354-.853l2.121-2.121a1.502 1.502 0 00-1.061-2.561c-.401 0-.778.156-1.061.438l-2.121 2.122a.5.5 0 11-.708-.707l2.121-2.122a2.483 2.483 0 011.767-.731c.669 0 1.297.26 1.768.731.472.472.732 1.1.732 1.768a2.48 2.48 0 01-.733 1.768l-2.121 2.121a.48.48 0 01-.35.147zm-4.95 4.123a2.48 2.48 0 01-1.768-.733 2.486 2.486 0 01-.732-1.768c0-.668.26-1.296.733-1.768l2.12-2.121a.5.5 0 11.708.707l-2.12 2.121a1.502 1.502 0 001.06 2.562 1.49 1.49 0 001.061-.439l2.121-2.119a.5.5 0 11.707.707l-2.121 2.119a2.488 2.488 0 01-1.769.732z","fill":"#F2994A"}}),_c('path',{attrs:{"d":"M15.232 20.443a.5.5 0 01-.354-.853l3.536-3.535a.5.5 0 11.708.707l-3.536 3.535a.501.501 0 01-.354.146zM4 3.926a.75.75 0 01-.041-1.497h.002a.256.256 0 01.089.001.23.23 0 01.045.005h.002a.747.747 0 01.653.741.75.75 0 01-.75.75zm2 0a.75.75 0 010-1.5l.048.004c.39.021.702.349.702.746a.75.75 0 01-.75.75zm2 0a.75.75 0 01-.04-1.497c.008-.001.024-.003.04-.003a.75.75 0 010 1.5z","fill":"#F2994A"}}),_c('path',{attrs:{"d":"M3 17.676a2.503 2.503 0 01-2.5-2.5v-12c0-1.379 1.121-2.5 2.5-2.5h16c1.378 0 2.5 1.121 2.5 2.5v6a.5.5 0 01-1 0v-3.5h-19v9.5c0 .827.673 1.5 1.5 1.5h6a.5.5 0 010 1H3zm17.5-13v-1.5c0-.827-.673-1.5-1.5-1.5H3c-.827 0-1.5.673-1.5 1.5v1.5h19z","fill":"#F2994A"}})])
          )
        }
      }
    